import api from '@/http'
import meta from '@/config/global.meta'
import jwtManager from '@/utility/JwtManager'
import logger from '@/utility/Logger'

const promises = {}

let token = meta.getAuthToken() || localStorage.getItem('user-token') || ''

logger.log('Raw Token', token)

let userData = {}
if (jwtManager.isValid(token)) {
  userData = jwtManager.decode(token).data
  logger.log('Using Existing Token', userData)
} else {
  token = ''
  logger.log('Resetting Token')
}

const state = {
  status: '',
  token: token,
  user: userData,
  location: setLocationDefault(),
  permissions: setPermissionsDefault(),
  config: setConfigDefault(),
  whiteLabel: setWhiteLabelDefault(),
  telephony: setTelephony(),
  agreementVersion: setAgreementVersion(),
  configLoaded: 0
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status
}

const actions = {
  async userData ({ dispatch, state }) {
    if (('userData' in promises)) {
      return promises.userData
    }

    promises.userData = new Promise((resolve, reject) => {
      dispatch('checkLogin').then(
        function () {
          resolve(state)
        }
      ).catch(error => {
        reject(error)
      })
    })

    return promises.userData
  },
  async accountingUser ({ state }) {
    if (('accountingUser' in promises)) {
      return promises.accountingUser
    }

    promises.accountingUser = new Promise((resolve, reject) => {
      api.authenticated().then((authStore) => {
        api.makeRequest('/backoffice/validUser/' + authStore.user.id).then(
          (data) => {
            if (data.data.results) {
              resolve()
            } else {
              reject()
            }
          }
        ).catch(() => {
          reject()
        })
      }).catch(() => {
        reject()
      })
    })

    return promises.accountingUser
  },
  async checkLogin ({ commit }) {
    try {
      var resp = await api.get('auth/status')

      logger.log('Auth Status', resp.data)

      commit('login', resp.data.token)
      commit('setLocation', resp.data.location)
      commit('setConfig', resp.data.config)
      commit('setPermissions', resp.data.permissions)
      commit('setWhiteLabel', resp.data.whiteLabel)
      commit('setTelephony', resp.data.telephony)
      commit('setAgreementVersion', resp.data.agreementVersion)
    } catch (err) {
      commit('loginError', err)
      throw err
    }
  },

  logout ({ commit }) {
    commit('logout')
  }
}

const mutations = {
  login (state, token) {
    state.token = token
    state.status = 'active'

    var data = jwtManager.decode(token)

    state.user = {
      id: data.sub,
      name: data.name,
      email: data.email
    }

    localStorage.setItem('user-token', token)
  },

  loginError (state) {
    state.status = 'error'
  },

  logout (state) {
    state.token = ''
    state.user = {}
    localStorage.removeItem('user-token')
    localStorage.removeItem('location')
    localStorage.removeItem('config')
    localStorage.removeItem('permissions')
    localStorage.removeItem('telephony')
  },

  setLocation (state, location) {
    state.location = location
    localStorage.location = JSON.stringify(location)
  },

  setConfig (state, config) {
    state.config = config
    localStorage.config = JSON.stringify(config)
    state.configLoaded = 1
  },

  setPermissions (state, permissions) {
    state.permissions = permissions
    localStorage.permissions = JSON.stringify(permissions)
  },

  setWhiteLabel (state, whiteLabel) {
    state.whiteLabel = whiteLabel
    localStorage.whiteLabel = JSON.stringify(whiteLabel)
  },

  setTelephony (state, telephony) {
    state.telephony = telephony
    localStorage.telephony = JSON.stringify(telephony)
  },

  setAgreementVersion (state, agreementVersion) {
    state.agreementVersion = agreementVersion
    localStorage.agreementVersion = JSON.stringify(agreementVersion)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

function setLocationDefault () {
  try {
    return JSON.parse(localStorage.location)
  } catch (e) {
    return {
      agencyName: 'Agency Matrix',
      office: {},
      district: {},
      region: {},
      division: {},
      territory: {}
    }
  }
}

function setPermissionsDefault () {
  try {
    return JSON.parse(localStorage.permissions)
  } catch (e) {
    return {
      PRbackOffice: 0,
      PRadmin: 0,
      PRowner: 0,
      PRshowOfficeMenuDropdown: 1,
      PRshowReportsMenuDropdown: 1,
      PRshowAdminMenuDropdown: 1,
      PRshowTrainingMenuDropdown: 1,
      PRshowLeadsMenuDropdown: 1,
      PRLeadViewIncubateTab: 1,
      PRLeadViewUnassignedTab: 1,
      PRLeadViewCallCenterTab: 1,
      PRoverrideTaskChanges: 0,
      PRoverrideOpenTaskChanges: 0,
      PRallowNotification: 0,
      agencyMatrixRaterAddOn: 0,
      PROfficeTab: 0,
      PRRolodexTab: 0,
      PRviewEOD: 0,
      dashboardView: 0,
      PRtraining: 0,
      PRLeadsTab: 0,
      PRFileLockerTab: 0,
      PRadmGPFagreement: 0,
      PRadmFinanceAgreement: 0,
      PRreceiptvoid: 0,
      BACKOFFICE_ACCOUNT_ADDONS: []
    }
  }
}

function setConfigDefault () {
  try {
    return JSON.parse(localStorage.config)
  } catch (e) {
    return {
      id: 0,
      liteSwitch: 1,
      isReceiveLeads: 0,
      themesId: 1,
      showFirstNameLastName: 1,
      custom1label: 'custom field 1',
      custom2label: 'custom field 2',
      custom3label: 'custom field 3',
      isEnabledRaterTab: 0
    }
  }
}

function setWhiteLabelDefault () {
  try {
    return JSON.parse(localStorage.whiteLabel)
  } catch (e) {
    return {
      customer: 'customer'
    }
  }
}

function setTelephony () {
  try {
    return (JSON.parse(localStorage.telephony))
  } catch (e) {
    return {
      telephonyActive: 0,
      telephonySubAccount: 0,
      whereAmI: 'None'
    }
  }
}

function setAgreementVersion () {
  try {
    return (JSON.parse(localStorage.agreementVersion))
  } catch (e) {
    return {
      isAgreementRequired: false
    }
  }
}
